var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFireplace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7242 63.8019C25.2382 62.5245 22.7437 61.2515 17.6795 60.9397C12.6152 60.6279 10.1473 60.9007 10.6347 63.646C11.029 65.9669 13.2444 65.811 17.52 65.811C21.7956 65.811 24.0109 65.5815 24.7242 63.8019Z",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4079 59.706C12.6458 58.5412 13.5408 45.4168 14.1744 44.3472C14.808 43.2777 23.0756 44.62 24.1833 44.62C25.291 44.62 24.2099 59.4375 24.0504 60.3642C23.8909 61.2908 19.1058 61.0223 17.3645 60.8664C15.6232 60.7106 13.9662 60.5547 13.4079 59.706Z",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6572 41.0085C14.1832 39.7744 16.5801 27.9836 18.7955 26.4334C21.0108 24.8833 25.282 29.1571 26.0706 30.5513C26.8593 31.9456 24.7946 42.2728 24.48 42.8877C24.1655 43.5026 21.9324 43.4636 19.7171 43.1388C17.8674 42.8785 16.1214 42.1433 14.6572 41.0085Z",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4178 30.3172C28.3039 30.3172 33.1023 27.9832 34.3385 26.143C35.3088 24.6967 31.8529 19.3058 30.9047 17.9158C29.9566 16.5259 26.3633 18.3488 24.148 20.1891C21.0022 22.7872 21.6003 23.9736 21.7598 24.7487C21.9193 25.5238 27.4178 30.3172 27.4178 30.3172Z",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6501 20.19C45.768 19.7198 45.9952 19.2824 46.314 18.9118C46.6328 18.5412 47.0347 18.2474 47.4884 18.0531C47.9422 17.8588 48.4357 17.7692 48.9306 17.7914C49.4255 17.8136 49.9085 17.9468 50.3422 18.1809C54.5114 20.4715 56.5761 22.3507 56.7179 23.8749C56.8287 25.0657 56.2438 26.4427 54.4671 27.8066C53.3711 28.5899 52.1806 29.2385 50.9226 29.7378C50.4004 29.9534 49.8278 30.025 49.267 29.9448C48.7061 29.8647 48.1785 29.6358 47.7414 29.2832L46.8552 28.586C46.018 27.9173 45.3921 27.0301 45.0501 26.0276C44.7082 25.025 44.6643 23.9483 44.9234 22.9223L45.6501 20.19Z",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9565 31.4776C49.9565 31.4776 51.4718 43.1688 51.7908 45.3338C52.1098 47.4988 60.342 46.0699 61.1307 45.2991C61.9193 44.5284 59.4116 30.4643 57.9893 28.4552C56.5671 26.446 49.9565 31.4776 49.9565 31.4776Z",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0341 48.3347C51.086 50.0364 52.0341 60.5715 52.6589 61.4981C53.2836 62.4247 59.1498 62.4247 61.0461 61.9614C62.9425 61.4981 62.3177 52.8206 62.3177 50.188C62.3177 47.5553 60.736 46.9404 57.413 46.9404C55.5218 46.9039 53.6582 47.387 52.0341 48.3347Z",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.265 61.7148C45.8538 66.0449 57.09 65.8154 60.732 65.967C64.374 66.1185 66.1153 65.8111 65.7963 63.646C65.4773 61.481 62.2517 61.5589 62.2517 61.5589",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2866 64.416H50.0262",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2694 64.4127C44.0303 64.543 47.7422 60.2768 47.5819 54.7942C47.5711 52.1962 46.8538 49.6476 45.5035 47.4087C45.3566 47.1785 44.9338 47.2697 44.9382 47.526C44.9649 48.8293 44.8002 51.0971 43.4873 52.3353C43.4873 51.9443 44.6801 47.274 42.5971 43.8811C41.2397 41.6307 38.9876 40.323 37.6524 39.7061C37.323 39.554 36.9447 39.8321 37.0916 40.1188C37.4667 40.8983 37.6773 41.7434 37.711 42.6039C37.7446 43.4645 37.6006 44.3228 37.2874 45.1279C36.5352 47.3001 31.4436 50.3846 29.8547 54.5596C28.7064 57.5746 29.4898 61.0762 31.7151 62.7705C33.9405 64.4648 37.1316 64.3562 37.1316 64.3562",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8873 12.4651C61.4387 11.567 61.8959 10.6168 62.2519 9.62891C62.2519 9.62891 59.8638 10.3434 58.4725 11.4649C57.2364 12.4608 56.9351 13.539 57.6662 14.0629C58.6365 14.7557 60.1828 13.6299 60.8873 12.4651Z",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8343 16.7818C17.7895 18.8429 23.5893 8.3252 23.5893 8.3252C23.7133 8.32953 11.2587 14.2877 14.8343 16.7818Z",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    "custom-rule": "true",
    d: "M6.43398 37.2196C8.59615 39.5839 9.53545 34.0977 9.53545 34.0977C9.53545 34.0977 4.52436 35.1325 6.43398 37.2196Z",
    fill: "#B250FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    "custom-rule": "true",
    d: "M40.2092 8.62835C41.9815 11.2827 43.7538 6 43.7538 6C43.7538 6 38.6275 6.28145 40.2092 8.62835Z",
    fill: "#B250FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    "custom-rule": "true",
    d: "M63.7847 32.0276C65.6455 33.7337 66 29.3906 66 29.3906C66 29.3906 62.1364 30.5208 63.7847 32.0276Z",
    fill: "#B250FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1012 15.5348C40.4924 15.4308 42.5748 15.9678 43.3723 16.076C43.8524 16.128 44.2948 16.3547 44.6117 16.7109C44.9285 17.0671 45.0967 17.5268 45.0826 17.9986C45.0117 20.5966 44.6794 25.5589 43.2173 26.0352C41.2235 26.6847 37.1251 26.5764 35.6851 26.2517C34.3559 25.9486 33.9129 21.2504 33.359 18.7823C33.1552 17.9379 33.3413 15.9678 39.1012 15.5348Z",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireplace);
export default __webpack_public_path__ + "static/media/fireplace.87243881a97e608882bbd079d1815263.svg";
export { ForwardRef as ReactComponent };